import React from "react";
import { Navigation, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import * as styles from "./style.mod.scss";
import RichText from "components/rich-text";
import { Container } from "react-bootstrap";

const TextSlider = ({ data }) => {
  const { slides } = data;

  const settings = {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    slidesPerGroup: 1,
    modules: [Navigation, Mousewheel],
    centeredSlides: false,
    pagination: { clickable: true },
    breakpoints: { 1024: { slidesPerView: 2 } },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  return (
    <div className={styles.textSliderContainer}>
      <Container>
        <div className={styles.textSlider}>
          <Swiper {...settings}>
            {slides?.map((item) => (
              <SwiperSlide key={item?._key}>
                <RichText blocks={item?.slide} />
              </SwiperSlide>
            )
            )}
          </Swiper>
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
      </Container>
    </div>
  );
};

export default TextSlider;